import React from 'react';
import '../../styles/LoadingScreen.css';

const LoadingScreen = ({ message = "Loading data..." }) => {
  return (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="database-icon">
          <div className="database-top"></div>
          <div className="database-middle"></div>
          <div className="database-bottom"></div>
        </div>
        <div className="sync-spinner">
          <div className="sync-arrow sync-arrow-right"></div>
          <div className="sync-arrow sync-arrow-left"></div>
        </div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;